export const EMAIL_VERIFICATION_DIALOG_TITLE = 'email-verification-dialog.title';
export const EMAIL_VERIFICATION_DIALOG_BUTTON_TEXT = 'email-verification-dialog.button-text';
export const EMAIL_VERIFICATION_DIALOG_ICON_ALT = 'email-verification-dialog.icon-alt';
